<div class="marine-insurance-disclaimer" [formGroup]="formGroup">
  <div class="custom-control custom-checkbox col-10">
    <app-control-wrapper [control]="formGroup.get('termsConfirmed')" [errors]="errors" [isShowHelper]="false">
      <div control-wrapper>
        <input type="checkbox" class="custom-control-input" id="disclaimer" [formControl]="formGroup.get('termsConfirmed')" />
        <label class="custom-control-label marine-insurance-disclaimer-label" for="disclaimer">
          {{ "MARINE_INSURANCE_TERMS_CONFIRM_PREFIX" | translate }}
          <a [routerLink]="['/legal-terms']">
            {{ "LABELS.LEGAL_TERMS_DISCLAIMER_LINK" | translate }}
          </a>
          {{ "MARINE_INSURANCE_TERMS_CONFIRM_SUFFIX" | translate }}
        </label>
      </div>
    </app-control-wrapper>
  </div>
  <div class="marine-insurance-disclaimer-icon">
    <span class="icon-ic_big_a"></span>
  </div>
</div>
